export default {
  id: 3,
  pride: 30720,
  slug: "north-stars",
  category: "game",
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "极北之星",
    en: "North Stars"
  },
  image: require('@/assets/images/ns_header.webp'),
  descriptionKey: {
    zh: "处女作。2015年起断断续续开发，2018年高二与几个同学们一起制作，全是策划。",
    en: "Debut work. Developed intermittently since 2015, created in 2018 during high school with several classmates. All planning."
  },
  date: { year: 2018, month: 6, day: 27 },
  genres: ["FPS", "网络联机"],
  themes: ["竞技"],
  engine: "虚幻引擎 4.12",
  platform: ["PC"],
  roles: {
    zh: "策划 (团队合作)",
    en: "Designer (Team Co-op)"
  },
  achievements: [
    { zh: "首日 2,000 同时在线", en: "2,000 peak concurrent users on day one" },
    { zh: "总计 20,000+ 玩家游玩", en: "20,000+ total players" }
  ],
  developerNotesKey: {
    zh: "steam处女作（2015-2018高中时期），网络联机的英雄射击。2018年免费上架，那个时候你随便发个独立游戏都能霸占steam首页一整天。在当时的朋友间广为流传说是佳作。",
    en: "Steam debut (2015-2018 high school era), an online hero shooter. Released for free in 2018, back when any indie game could dominate the Steam front page for a whole day. Widely praised as a masterpiece among friends at the time."
  },
  tags: ["联机"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "steam", url: "https://store.steampowered.com/app/843050/North_Stars/", textKey: { zh: "Steam 商店", en: "Steam Store" } },
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1Q54y1W7e2/", textKey: { zh: "后期宣传片", en: "Late Promo Video" } }
  ]
};
